/**
 * Adds target=_blank attr to certain links
 *
 * @package  Globus
 * @since    1.0.0
 */

import $ from 'jquery';

$('.google_map_link').each(
	function () {
		$(this).attr('target', '_blank');
	},
);

$('.application_details a').each(
	function () {
		$(this).attr('target', '_blank');
	},
);
